export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_09-cd17d2ff9fef5d19a0cb4b6fb6fe6877.jpg";